module.exports = __webpack_public_path__ + "static/media/country_gw.3722a98f.webp";